import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getDateCartStock } from '../../discount/internal/Common';
import { useLocalization, useTranslate } from '@im/react-localization';
import { styled } from '@mui/material/styles';
import { useFeatureFlag } from 'mf_core/feature-flag';
import { TableSkeleton } from '@im/ui-lib/TableSkeleton';

type PropTypes = {
  fromPage: string;
  siteCode: string;
  warehouseStockDetailUpdate: any;
};
const WarehouseGridData = (props: PropTypes) => {
  const translate = useTranslate();
  const { formatCurrency, formatDate } = useLocalization();

  const { isReady, value: configKey } = useFeatureFlag([
    'X4C_WarehousePopup_IDSGMY',
  ]);

  const whPopupKey = isReady
    ? configKey['X4C_WarehousePopup_IDSGMY'] === 'true'
    : false;

  function getNum(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  return (
    <>
      {isReady ? (
        <WarehouseDetailsBody container>
          <Grid
            container
            sx={{ alignContent: 'flex-start', display: 'flex', flex: 1 }}
          >
            <WarehouseTableHeader container>
              <Grid item xs={3}>
                {translate('Warehouse.ColumnLoc')}
              </Grid>
              <Grid item xs={2}>
                {translate('Common.Stock')}
              </Grid>
              <Grid item xs={2}>
                {translate('Common.OnOrder')}
              </Grid>
              <Grid item xs={props.siteCode.toUpperCase() === 'BR' ? 3 : 4}>
                {translate('Common.LeadTimeETA')}
              </Grid>

              {props.siteCode.toUpperCase() === 'BR' && (
                <>
                  <Grid item xs={2}>
                    {translate('BrazilWH.Price')}
                  </Grid>
                </>
              )}
            </WarehouseTableHeader>
            <Box sx={{ height: '300px', overflow: 'auto', width: '100%' }}>
              <Grid container sx={{ paddingLeft: '0rem' }}>
                {props.warehouseStockDetailUpdate?.map(
                  (warehouse: any, i: number) => (
                    <React.Fragment key={`warehouseStockDetail-${i}`}>
                      <Grid
                        container
                        key={i}
                        sx={{
                          borderBottom: 1,
                          borderBottomColor: '#C4C4C4',
                          p: 1.5,
                        }}
                      >
                        <Grid item xs={3}>
                          <Typography title={warehouse.name || ''}>
                            {warehouse.name === 'NotAvailable' ||
                            warehouse.id === 'Reserved'
                              ? translate('Common.Reserved')
                              : warehouse.name}{' '}
                            {warehouse.id === 'Reserved' ? (
                              <ReservedIcon component="span">R</ReservedIcon>
                            ) : (
                              ''
                            )}
                          </Typography>
                        </Grid>
                        {whPopupKey &&
                        warehouse.quantityAvailable !== undefined &&
                        warehouse.quantityAvailable !== null &&
                        warehouse.quantityAvailable > 0 ? (
                          <Grid xs={2}>{translate('Common.Instock')}</Grid>
                        ) : (
                          whPopupKey && (
                            <Grid item pl={1} xs={2}>
                              {'-'}
                            </Grid>
                          )
                        )}

                        {!whPopupKey && (
                          <Grid item pl={1} xs={2}>
                            {warehouse.quantityAvailable || 0}
                          </Grid>
                        )}
                        {whPopupKey &&
                        warehouse.quantityOnOrder !== undefined &&
                        warehouse.quantityOnOrder !== null &&
                        warehouse.quantityOnOrder?.length > 0 ? (
                          <>
                            <Grid item pl={2} xs={3}>
                              {translate('Common.yes')}
                            </Grid>
                            <Grid item pl={2} xs={3}>
                              {warehouse.quantityOnOrderEta || '-'}
                            </Grid>
                          </>
                        ) : (
                          whPopupKey && (
                            <>
                              <Grid item pl={2} xs={1}>
                                {translate('Common.no')}
                              </Grid>
                              <Grid item pl={2} xs={1}>
                                {props.fromPage === 'cart' &&
                                warehouse.estimatedLeadTime !== undefined
                                  ? formatDate(
                                      new Date(
                                        getDateCartStock(
                                          warehouse.estimatedLeadTime
                                        )
                                      )
                                    ) || '-'
                                  : formatDate(warehouse.estimatedLeadTime) ||
                                    '-'}
                              </Grid>
                            </>
                          )
                        )}

                        {!whPopupKey &&
                        warehouse.quantityOnOrder !== undefined &&
                        warehouse.quantityOnOrder !== null &&
                        warehouse.quantityOnOrder?.length > 0 ? (
                          <>
                            <Grid item pl={2} xs={2}>
                              {warehouse.quantityOnOrder || 0}
                            </Grid>
                            <Grid item pl={2} xs={3}>
                              {warehouse.quantityOnOrderEta || '-'}
                            </Grid>
                          </>
                        ) : (
                          !whPopupKey && (
                            <>
                              <Grid item pl={2} xs={2}>
                                {warehouse.onOrderQuantity || 0}
                              </Grid>
                              {props.siteCode.toUpperCase() === 'BR' ? (
                                <Grid item pl={2} xs={3}>
                                  {props.fromPage === 'cart' &&
                                  warehouse.estimatedLeadTime !== undefined
                                    ? formatDate(
                                        new Date(
                                          getDateCartStock(
                                            warehouse.estimatedLeadTime
                                          )
                                        )
                                      ) || '-'
                                    : formatDate(warehouse.estimatedLeadTime) ||
                                      '-'}
                                </Grid>
                              ) : (
                                <Grid item pl={2} xs={2}>
                                  {props.fromPage === 'cart' &&
                                  warehouse.estimatedLeadTime !== undefined
                                    ? formatDate(
                                        new Date(
                                          getDateCartStock(
                                            warehouse.estimatedLeadTime
                                          )
                                        )
                                      ) || '-'
                                    : formatDate(warehouse.estimatedLeadTime) ||
                                      '-'}
                                </Grid>
                              )}
                            </>
                          )
                        )}

                        {props.siteCode.toUpperCase() === 'BR' && (
                          <Grid item pl={1} xs={2}>
                            {formatCurrency(getNum(warehouse.price)) || 0}
                          </Grid>
                        )}
                      </Grid>
                    </React.Fragment>
                  )
                )}
              </Grid>
            </Box>
          </Grid>
          <Grid container mt={2} rowSpacing={1}>
            <Grid item xs={12}>
              <Typography component="span" fontWeight="bold">
                {translate('Common.Leadtime')}
                {props.fromPage === 'cart' ? '*' : ''} :{' '}
              </Typography>
              <Typography component="span">
                {translate('Product.Warehouseorderplacedmsg')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component="span" fontWeight="bold">
                {translate('Common.ETAInfo_Heading')}
                {props.fromPage === 'cart' ? '*' : ''}:{' '}
              </Typography>
              <Typography component="span">
                {translate('Product.Warehouseorderconfirmationmsg')}
              </Typography>
            </Grid>
          </Grid>
        </WarehouseDetailsBody>
      ) : (
        <TableSkeleton
          columns={[
            '----------------------------------------------------------------------------',
            '--------------------',
            '-------------------------------------------------',
            '--------------------',
            '------------------------------------',
            '----------------------------------------------------------',
          ]}
          key={props.fromPage}
          rows={4}
        />
      )}
    </>
  );
};

export default WarehouseGridData;

const WarehouseDetailsBody = styled(Grid)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  typography: 'body1',
  width: '100%',
}));

const WarehouseTableHeader = styled(Grid)(({ theme }) => ({
  '& .MuiGrid-item': { alignItems: 'flex-end', display: 'flex' },
  backgroundColor: '#F8F8F8',
  borderBottom: 'solid 2px #0077D4',
  display: 'flex',
  flexWrap: 'nowrap',
  fontSize: '14px',
  fontWeight: 'bold',
  padding: theme.spacing(3, 1.5, 0.5),
}));

const ReservedIcon = styled(Box)(() => ({
  alignItems: 'center',
  backgroundColor: '#18846F',
  borderRadius: '50%',
  color: 'white',
  display: 'inline-flex',
  height: 24,
  justifyContent: 'center',
  width: 24,
}));
